export const pages = Object.freeze({
	bestsellers: '/bestsellers',
	news: '/news',
	popular: '/popular',
	recentlyViewedProducts: '/recentlyviewedproducts',
	newProducts: '/newproducts',
	cart: '/cart',
})

const checkoutRoutes = Object.freeze({
	getSettings: '/opccheckoutsettings/',
	getCustomerAddresses: '/addresses/',
	getPaymentMethods: '/opcpayments/',
	getShippingMethods: '/opccheckoutshipping/',
	saveShippingAddress: '/saveshipping/',
	saveBillingAddress: '/opcsavebilling/',
})

const routes = Object.freeze({
	quicksearch: term => `/catalog/searchtermautocomplete?term=${term}`,

	basket: {
		add: (id, type) => `/addproducttocart/details/${id}/${type}`,
	},

	cart: {
		add: (id, type, quantity = 1, endpoint) => {
			if (endpoint == 'details') {
				return `/addproducttocart/${endpoint}/${id}/${type}`
			}

			return `/addproducttocart/${endpoint}/${id}/${type}/${quantity}`
		},
		quantity: id => `/cart/quantity/${id}`,
		remove: id => `/removeItemFromCart/${id}`,
		get: '/flyoutcart',
		applyDiscount: 'flyoutcart/applydiscountcoupon',
		applyGiftCard: 'flyoutcart/applygiftcardcoupon',
		removeDiscount: 'flyoutcart/removediscountcouponcode',
		removeGiftCard: 'flyoutcart/removegiftcardcouponcode',
		updateCheckoutAttributes: 'flyoutcart/updateCheckoutAttributes',
		uploadFile: id => `uploadfilecheckoutattribute/${id}`,
	},

	wishlist: {
		add: (id, type, quantity = 1) => `/addproducttocart/catalog/${id}/${type}/${quantity}`,
		addDetails: (id, type) => `/addproducttocart/details/${id}/${type}`,
		remove: id => `/removeItemFromWishlist/${id}`,
		quantity: id => `/wishlist/quantity/${id}`,
		get: '/flyoutwishlist',
	},

	comparelist: {
		add: id => `/compareproducts/add/${id}`,
		remove: id => `/compareproducts/remove/${id}`,
		clearList: '/clearcomparelist',
	},

	getVariantSpecs: (id, combinationId) => `/variantspecs?id=${id}&combinationId=${combinationId}`,

	checkout: {
		...checkoutRoutes,
	},
})

export default routes
